import * as React from "react";
import { BlockItem } from "./BlockItem";
import { useMenu } from "./useMenu";

type Props = {
  onClickOnAnyLink: () => void;
  onChildOpen: (isOpen: boolean) => void;
};

export function CategoryBlock({ onClickOnAnyLink, onChildOpen }: Props) {
  const [, { children }] = useMenu().items.all;

  return (
    <ul
      aria-label={`${children.map(item => item.label).join(", ")}`}
      className="elm-m-0 elm-mt-2 elm-mb-5 elm-p-0 elm-grid elm-grid-flow-row elm-grid-cols-2 elm-gap-2 elm-list-none"
    >
      {children.map((item, idx) => (
        <BlockItem
          categoryButtonChildren={
            <span className="elm-flex-grow elm-text-center elm-pointer-events-none">
              {item.label}
            </span>
          }
          key={idx}
          label={item.label}
          onClickOnAnyLink={onClickOnAnyLink}
          onChildOpen={onChildOpen}
          children={item.children}
          className="elm-transition elm-bg-dd-blue-50 elm-h-20 md:elm-h-24 elm-flex elm-rounded-xl lg:hover:elm-bg-dd-blue-100 lg:hover:elm-text-dd-gray-500"
        />
      ))}
    </ul>
  );
}
